import { render, staticRenderFns } from "./Detective.vue?vue&type=template&id=4ba04cc0&scoped=true&"
import script from "./Detective.vue?vue&type=script&lang=js&"
export * from "./Detective.vue?vue&type=script&lang=js&"
import style0 from "../components/css/Style.css?vue&type=style&index=0&id=4ba04cc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba04cc0",
  null
  
)

export default component.exports